import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import icons from '../../assets/comet/comet.svg';
import './styles.styl';
import AudioToggles from '../AudioToggles';

class Voiceover extends Component {
  constructor(props) {
    super(props);

    this.waitingToPlay = false;

    this.state = {
      autoplayIsBlocked: false,
      canPlayThrough: !props.audioEnabled,
      hasPlayedThrough: false
    };
  }

  componentDidMount() {
    if (this.props.autoPlay) {
      this.playAudio();
    }

    if (this.props.onCanPlayThrough) {
      this.props.onCanPlayThrough(this.state.canPlayThrough);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      (nextProps.audioEnabled && !this.props.audioEnabled) ||
      (nextProps.sources && nextProps.sources !== this.props.sources)
    ) {
      // If the <audio> tag is about to be newly rendered,
      // set canPlayThrough to false since the src may need to download.
      //
      // By doing this in WillReceiveProps when the component hasn't yet re-rendered,
      // we should avoid any scenario where this would happen after the canPlayThrough() event is triggered

      this.setState({
        canPlayThrough: false
      });

      if (this.props.autoPlay) {
        this.waitingToPlay = true;
      }
    }

    if (this.props.paused && !nextProps.paused) {
      this.waitingToPlay = true;
    } else if (this.audio && !this.props.paused && nextProps.paused) {
      this.waitingToPlay = false;
      this.audio.pause();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.onCanPlayThrough) {
      this.props.onCanPlayThrough(this.state.canPlayThrough);
    }
    if (this.waitingToPlay) {
      this.waitingToPlay = false;
      this.playAudio();
    }
  }

  canPlayThrough = () => {
    this.setState({
      canPlayThrough: true
    });
  };

  ended = () => {
    this.setState({
      hasPlayedThrough: true
    });

    if (this.props.onEnded) {
      this.props.onEnded();
    }
  };

  playAudio = () => {
    if (this.audio && this.props.sources) {
      if (!this.state.canPlayThrough) {
        this.waitingToPlay = true;
      } else {
        if (this.props.hasPlayedThrough) {
          this.audio.currentTime = 0;
        }
        let audioPlayPromise = this.audio.play();
        if (audioPlayPromise !== undefined) {
          audioPlayPromise
            .then(() => {
              this.setState({
                autoplayIsBlocked: false
              });
            })
            .catch(error => {
              if (error.name === 'NotAllowedError') {
                this.setState({
                  autoplayIsBlocked: true
                });
              } else if (error.name === 'NotSupportedError') {
                console.warn('Unsupported media type! ' + error);
              } else {
                console.error('Unknown audio playback error! ' + error);
              }
            });
        }
      }
    }
  };

  hideTranscript = () => {
    this.props.transcriptOff();
  };

  render() {
    const { sources, transcript, hidden } = this.props;
    // <track> doesn't work within <audio> but jsx-a11y doesn't acknowledge this
    /* eslint-disable jsx-a11y/media-has-caption */
    const audio = this.props.audioEnabled ? (
      <audio
        ref={e => {
          this.audio = e;
        }}
        controls={this.state.autoplayIsBlocked}
        controlsList="nodownload"
        preload="auto"
        onCanPlayThrough={this.canPlayThrough}
        onEnded={this.ended}
      >
        {sources.map(function(source, index) {
          return <source key={index} type="audio/mpeg" {...source} />;
        })}
      </audio>
    ) : null;
    /* eslint-enable jsx-a11y/media-has-caption */

    return (
      <Fragment>
        {transcript && <AudioToggles hidden={hidden} />}
        <div className="voiceover-audio" hidden={!this.state.autoplayIsBlocked}>
          {audio}
        </div>

        {transcript && (
          <div
            className="voiceover-transcript"
            hidden={!this.props.transcriptEnabled || hidden}
          >
            <h2 className="voiceover-transcript__heading">Audio Transcript</h2>

            {transcript}

            <button
              className="voiceover-transcript__close-button"
              onClick={this.hideTranscript}
            >
              <svg
                className="comet-icon--l"
                aria-hidden="true"
                focusable="false"
              >
                <use xlinkHref={`${icons}#x`} />
              </svg>
              <span className="comet-screenreader-only">Close Transcript</span>
            </button>
          </div>
        )}
      </Fragment>
    );
  }
}

Voiceover.defaultProps = {
  autoPlay: true,
  sources: [],
  transcript: null
};

Voiceover.propTypes = {
  autoPlay: PropTypes.bool,
  onCanPlayThrough: PropTypes.func,
  onEnded: PropTypes.func,
  paused: PropTypes.bool,
  sources: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string.isRequired,
      type: PropTypes.string
    })
  ),
  transcript: PropTypes.oneOfType([PropTypes.node, PropTypes.oneOf([false])])
};

export default Voiceover;



// WEBPACK FOOTER //
// ../core/src/components/Voiceover/Voiceover.js